
import React, { Component}  from 'react';

import { FormContext } from 'core/FormProvider';
import { ContextFormControlWidget, ContextWidget } from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import { AsyncSelectWidget } from 'form/SelectAsync';
import { SelectWidget } from 'form/Select';
import FormGroup from 'form/FormGroup';
import { CheckboxWidget } from "form/Checkbox";


export class ServiceForm extends Component {

  render() {
    return (
      <FormContext.Consumer>
        {context => {
          return (
            <FormGroup>
              <ContextWidget
                name={'name'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Название',
                  required: true
                }}
              />

              <ContextFormControlWidget
                name={'type'}
                label={'Тип услуги'}
                WidgetComponent={SelectWidget}
                widgetProps={{
                  label: 'Тип услуги',
                  options: [
                    {value: 'TARIFF', label: 'Услуга тарифа'},
                    {value: 'ORDER', label: 'Дополнительная услуга'},
                  ]
                }}
              />

              <ContextFormControlWidget
                name={'tariffication'}
                label={'Тарификация'}
                WidgetComponent={SelectWidget}
                widgetProps={{
                  label: 'Тарификация',
                  options: [
                    {value: 'FIXED', label: 'Фиксированная'},
                    {value: 'BY_MILEAGE', label: 'По километражу'},
                  ]
                }}
              />

              <ContextFormControlWidget
                name={'financial_schema'}
                label={'Финансовая схема'}
                WidgetComponent={SelectWidget}
                widgetProps={{
                  label: 'Финансовая схема',
                  options: [
                    {value: 'RE_EXPOSED', label: 'Перевыставляемая'},
                    {value: 'OWN', label: 'Собственная'},
                  ]
                }}
              />

              <ContextFormControlWidget
                name={'container_type'}
                label={'Типоразмер контейнера'}
                WidgetComponent={AsyncSelectWidget}
                widgetProps={{
                  url: 'catalog/choice',
                  label: 'Типоразмер контейнера',
                  optionLabel: 'name',
                  filter: {
                    type: 'CONTAINER_TYPE'
                  }
                }}
              />

              <ContextWidget
                name={'description'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Описание'
                }}
              />

              <ContextWidget
                name={`is_active`}
                WidgetComponent={CheckboxWidget}
                widgetProps={{
                  label: 'Активность'
                }}
              />

            </FormGroup>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
